import request from '../../../request'
import {req} from "vuelidate/lib/validators/common";

export default {
  actions: {
    // list all employees
    getEmployees (_, parameters) {
      return request.get('employees', {
        params: parameters
      })
    },

    // list all employees
    getEmployee (_, id) {
      return request.get('employees/' + id);
    },

    // create new employee
    createEmployee (_, payload) {
      return request.post('employees', payload)
    },

    payAdvance(_, payload) {
      return request.post('pay-advance', payload);
    },

    createEmployeeVSelect (_, payload) {
      return request.post('employees?response=vselect', payload)
    },

    // update employee
    updateEmployee (_, payload) {
      return request.put('employees/' + payload.id, payload.employee)
    },

    // delete employee
    deleteEmployee (_, id) {
      return request.delete('employees/' + id)
    },

    getEmployeeAdvanceHistory(_, id) {
      return request.get('employee-history/' + id);
    },

    getEmployeePermit(_,id){
     return request.get('permits/'+id);
    },

    storePermit(_,payload){
      return request.post('permits',payload);
    },

    deletePermit(_,id){
      return request.delete('permits/'+id);
    }
  }
}